import {
  API_CALL_ERROR,
  BaseActionType,
  BEGIN_API_CALL,
  END_API_CALL,
} from '../actions/actionTypes'

const initialState = 0
export default function apiCallStatusReducer(
  state: number = initialState,
  action: BaseActionType,
): number {
  if (action.type === BEGIN_API_CALL) {
    return state + 1
  } else if (
    action.type === API_CALL_ERROR ||
    actionTypeEndsInSuccess(action.type) ||
    action.type === END_API_CALL
  ) {
    return state - 1
  }

  return state
}

const actionTypeEndsInSuccess = (type: string) =>
  type.substring(type.length - 8) === '_SUCCESS'
